import Reflux from 'reflux';
import find from 'lodash/find';
import actions from '../actions';
import configurationStore from './configuration-store';
import stateStore from './state-store';

export default Reflux.createStore({
	listenables: actions,

	init() {
		this.listenTo(configurationStore, this.onConfigurationChange);
		this.listenTo(stateStore, this.onStateChange);

		this.state = {
			facets: {},
			configuration: {
				preselection: {},
				visibleFacets: []
			}
		};
	},

	onLoadFacetsCompleted(facets) {
		facets = this.state.configuration.visibleFacets.map(facetId => facets.find(facet => facet.id === facetId));
		facets = this._mapFacets(facets);
		this.state.facets = facets;
		actions.facetsLoaded();
		this.output();
	},

	_mapProperty(property, facet) {
		// special sorting and label for numeric properties, defined per facet
		if (facet.propertyType === 'numeric') {
			property.sort = parseInt(property.label, 10);
			property.label = `${property.label} ${facet.unitLabel}`;
		}
		return property;
	},

	_mapFacet(facet) {
		facet.properties = facet.properties.map(property => this._mapProperty(property, facet));

		let mappedProperties = {};
		facet.properties
			.forEach((property) => {
				if (property) mappedProperties[property.id] = property;
			});
		facet.properties = mappedProperties;
	},

	_mapFacets(facets) {
		facets
			.filter(facet => facet)
			.map(facet => this._mapFacet(facet));

		let mappedFacets = {};
		facets
			.forEach((facet) => {
				if (facet) mappedFacets[facet.id] = facet;
			});
		return mappedFacets;
	},

	onStateChange(state) {
		this.state.userSelection = state.userSelection;
	},

	onConfigurationChange(configuration) {
		this.state.configuration = configuration;
		// we assume this does not change so we do not trigger here
	},

	getState() {
		return {facets: this.state.facets};
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
});
